import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1000",
  height: "600",
  viewBox: "0 0 5 3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("desc", null, "Flag of Germany", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  id: "black_stripe",
  width: "5",
  height: "3",
  y: "0",
  x: "0",
  fill: "#000"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  id: "red_stripe",
  width: "5",
  height: "2",
  y: "1",
  x: "0",
  fill: "#D00"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  id: "gold_stripe",
  width: "5",
  height: "1",
  y: "2",
  x: "0",
  fill: "#FFCE00"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }